import {
  aiSystemAssessmentRouteUtil,
  candidateAgentAssessmentRouteUtil,
  candidateModelAssessmentRouteUtil,
  functionalModelAssessmentRouteUtil,
} from '~/client/routes';
import * as GQL from '~/graphql/generated/client';

interface NavigateToAssessmentParams {
  assessmentId: string;
  project: {
    projectId: string | undefined;
    candidateId: string | undefined;
    functionalModelId: string | undefined;
    agentId: string | undefined;
  };
  routeUtils: {
    aiSystem: ReturnType<typeof aiSystemAssessmentRouteUtil.useHelper>;
    functionalModel: ReturnType<
      typeof functionalModelAssessmentRouteUtil.useHelper
    >;
    candidateModel: ReturnType<
      typeof candidateModelAssessmentRouteUtil.useHelper
    >;
    candidateAgent: ReturnType<
      typeof candidateAgentAssessmentRouteUtil.useHelper
    >;
  };
}

/**
 * Helper function to navigate to the correct assessment route based on project type
 */
export const navigateToAssessment = ({
  assessmentId,
  project,
  routeUtils,
}: NavigateToAssessmentParams) => {
  try {
    // If it's a candidate model
    if (project.candidateId && project.functionalModelId) {
      return routeUtils.candidateModel.navigateTo('LANDING', {
        params: {
          projectId: project.projectId ?? '',
          functionalModelId: project.functionalModelId ?? '',
          candidateId: project.candidateId,
          assessmentId,
        },
        replace: true,
      });
    }
    if (project.agentId && project.functionalModelId) {
      return routeUtils.candidateAgent.navigateTo('LANDING', {
        params: {
          projectId: project.projectId ?? '',
          functionalModelId: project.functionalModelId ?? '',
          agentId: project.agentId,
          assessmentId,
        },
      });
    }

    // If it's a functional model
    if (project.functionalModelId && project.projectId) {
      return routeUtils.functionalModel.navigateTo('LANDING', {
        params: {
          projectId: project.projectId,
          functionalModelId: project.functionalModelId ?? '',
          assessmentId,
        },
      });
    }

    // If it's an AI system
    if (project.projectId) {
      return routeUtils.aiSystem.navigateTo('LANDING', {
        params: {
          projectId: project.projectId,
          assessmentId,
        },
        replace: true,
      });
    }

    console.error('Unable to navigate: unknown project type');
  } catch (error) {
    console.error('Navigation error:', error);
  }
};
